$(document).ready(function () {
  // console.log("sadas");
  var selected_id = jQuery("#selected_variant_id option:selected").val();
  $("#mainProductId").val(selected_id);

  function randomString(length, chars) {
    var result = "";
    for (var i = length; i > 0; --i)
      result += chars[Math.floor(Math.random() * chars.length)];
    return result;
  }
  var rString = randomString(
    16,
    "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"
  );

  $("#GroupId").val(rString);

  const myHeaders = new Headers();
});

jQuery.getJSON("/cart.js", function (cartData) {
  console.log(cartData, "------------cartData");
});

$(document).on("click", ".product__chip", function () {
  var variantOptions = [
    // maps start---
    // "XL (30” x 50.5”)",
    // "2XL (37.5” x 63.25”)",
    // // "2XL (37.5” x 63”)"
    // "3XL (45” x 76”)",
    //---maps end
    //pano start--
    // "Large (22.5” x 70”)",
    // "Medium (18.75” x 58.25”)",
    // "Schmedium (15” x 46.5”)",
    // "XL (26.25” x 82”)",
    //---pano end
    //patents start ---
    // "XL (30” x 40”)",
    // -----patents end
  ];

  $(".product__color-swatch").removeClass("disabled_variant");
  $(".product_font_swatch").removeClass("disabled_variant");
  let title = $(this).data("value");
  if ($.inArray(title, variantOptions) !== -1) {
    var button_array = document.querySelectorAll(
      '[data-sub_title="' + title + '"]'
    );
    let arrayy = Array.from(button_array);
    $.each(arrayy, function (key, value) {
      let var_sub_title = $(this).data("title");
      var_sub_title = var_sub_title.split(" / ");
      let swatch_color_button = document.querySelector(
        '[data-value="' + var_sub_title[1] + '"]'
      );
      if (swatch_color_button) {
        swatch_color_button.classList.add("disabled_variant");
      }

      if (var_sub_title.length > 2) {
        let swatch_font_button = document.querySelector(
          '[data-value="' + var_sub_title[2] + '"]'
        );
        if (swatch_font_button) {
          swatch_font_button.classList.add("disabled_variant");
        }
      }
    });
  }
  setTimeout(function (params) {
    let url = window.location.href;
    url = url.split("variant=");
    let variant_id = url[1];

    let mainProduct_variantId;
    if (variant_id) {
      $("#mainProductId").val(variant_id);
    } else {
      $("#mainProductId").val();
    }
    var selectedSize = $("input[name='Size']:checked").val();
    var selectedColor = $("input[name='Color']:checked").val();
    var variants = $("#variantsJson").val();
    if (variants) {
      JSON.parse(variants).forEach((variant) => {
        if (
          variant.option1 == selectedSize &&
          variant.option2 == selectedColor
        ) {
          $("#productId_map").val(variant.id);
        }
      });
    }
  }, 500);
});

$(document).on("click", ".variant-input", function () {
  var variantOptions = [
    // maps start---
    // "XL (30” x 50.5”)",
    // "2XL (37.5” x 63.25”)",
    // // "2XL (37.5” x 63”)"
    // "3XL (45” x 76”)",
    //---maps end
    //pano start--
    // "Large (22.5” x 70”)",
    // "Medium (18.75” x 58.25”)",
    // "Schmedium (15” x 46.5”)",
    // "XL (26.25” x 82”)",
    //---pano end
    //patents start ---
    // "XL (30” x 40”)",
    // -----patents end
  ];

  setTimeout(function (params) {
    var selectedSize = $("input[name='Size']:checked").val();

    if ($.inArray(selectedSize, variantOptions) !== -1) {
      $(".submit_btn_addcart").prop("disabled", true);
      $(".submit_btn_textt").text("Sold out");
    } else {
      $(".submit_btn_addcart").prop("disabled", false);
      $(".submit_btn_textt").text("Add to Cart");
    }
  }, 300);
});

$("body").on("click", "#addToCartNew", function () {
  var personalized_prod_id = "";
  var tag = $("#tags").val();
  if (tag == "+$39 PERSONALIZATION") {
    personalized_prod_id = 40863986155638;
  } else if (tag == "+$12 PERSONALIZATION") {
    personalized_prod_id = 41107296026742;
  } else if (tag == "+$16 PERSONALIZATION") {
    personalized_prod_id = 41107291242614;
  } else if (tag == "+$20 PERSONALIZATION") {
    personalized_prod_id = 41107282690166;
  }
  var address1 = $("#address_1").val();
  var address2 = $("#address_2").val();
  var address3 = $("#address_3").val();
  var address4 = $("#address_4").val();
  var address5 = $("#address_5").val();
  var address6 = $("#address_6").val();
  var address7 = $("#address_7").val();
  var address8 = $("#address_8").val();
  var address9 = $("#address_9").val();
  var address10 = $("#address_10").val();
  var address111 = $("#address_11").val();
  var address12 = $("#address_12").val();
  var address13 = $("#address_13").val();
  var address14 = $("#address_14").val();
  var address15 = $("#address_15").val();

  var address11 = $("#text_address_11").val();
  if (address11 && !$(".text_field1").hasClass("hide")) {
    address1 = address11;
    $("#custom_text1").val(address11);
  }

  var address21 = $("#text_address_21").val();
  if (address21 && !$(".text_field2").hasClass("hide")) {
    address2 = address21;
    $("#custom_text2").val(address21);
  }

  var address31 = $("#text_address_31").val();
  if (address31 && !$(".text_field3").hasClass("hide")) {
    address3 = address31;
    $("#custom_text3").val(address31);
  }

  if ($(".city_state1").length > 0) {
    if ($('input[name="customization"]:checked').val() == "yes") {
      var city1 = $("#city_state1").val();
      var city2 = $("#city_state2").val();
      var city3 = $("#city_state3").val();
      var city4 = $("#city_state4").val();
      var city5 = $("#city_state5").val();
      var city6 = $("#city_state6").val();
      var city7 = $("#city_state7").val();
      var city8 = $("#city_state8").val();
      var city9 = $("#city_state9").val();
      var city10 = $("#city_state10").val();
      var city11 = $("#city_state11").val();
      var city12 = $("#city_state12").val();
      var city13 = $("#city_state13").val();
      var city14 = $("#city_state14").val();
      var city15 = $("#city_state15").val();

      let formData;

      if ($('input[name="customization1"]:checked').val() == "yes") {
        if ($('input[name="customization2"]:checked').val() == "yes") {
          if ($('input[name="customization3"]:checked').val() == "yes") {
            if ($('input[name="customization4"]:checked').val() == "yes") {
              if ($('input[name="customization5"]:checked').val() == "yes") {
                if ($('input[name="customization6"]:checked').val() == "yes") {
                  if (
                    $('input[name="customization7"]:checked').val() == "yes"
                  ) {
                    if (
                      $('input[name="customization8"]:checked').val() == "yes"
                    ) {
                      if (
                        $('input[name="customization9"]:checked').val() == "yes"
                      ) {
                        if (
                          $('input[name="customization10"]:checked').val() ==
                          "yes"
                        ) {
                          if (
                            $('input[name="customization11"]:checked').val() ==
                            "yes"
                          ) {
                            if (
                              $(
                                'input[name="customization12"]:checked'
                              ).val() == "yes"
                            ) {
                              if (
                                $(
                                  'input[name="customization13"]:checked'
                                ).val() == "yes"
                              ) {
                                if (
                                  $(
                                    'input[name="customization14"]:checked'
                                  ).val() == "yes"
                                ) {
                                  formData = {
                                    items: [
                                      {
                                        id: personalized_prod_id,
                                        quantity: 1,
                                        properties: {
                                          _Hide: true,
                                          _GroupId: $("#GroupId").val(),
                                        },
                                      },
                                      {
                                        id: 41779136888950,
                                        quantity: 1,
                                        properties: {
                                          _Hide: true,
                                          _GroupId: $("#GroupId").val(),
                                        },
                                      },
                                    ],
                                  };

                                  if (
                                    city1 &&
                                    city2 &&
                                    city3 &&
                                    city4 &&
                                    city5 &&
                                    city6 &&
                                    city7 &&
                                    city8 &&
                                    city9 &&
                                    city10 &&
                                    city11 &&
                                    city12 &&
                                    city13 &&
                                    city14 &&
                                    city15
                                  ) {
                                    jQuery.ajax({
                                      url:
                                        window.Shopify.routes.root +
                                        "cart/add.js",
                                      type: "POST",
                                      data: formData,
                                      async: false,
                                      success: function (result) {
                                        console.log("----successfully added");
                                      },
                                    });
                                  }
                                } else {
                                  if (
                                    $(
                                      'input[name="customization14"]:checked'
                                    ).val() == "no"
                                  ) {
                                    formData = {
                                      items: [
                                        {
                                          id: personalized_prod_id,
                                          quantity: 1,
                                          properties: {
                                            _Hide: true,
                                            _GroupId: $("#GroupId").val(),
                                          },
                                        },
                                        {
                                          id: 41779136888950,
                                          quantity: 1,
                                          properties: {
                                            _Hide: true,
                                            _GroupId: $("#GroupId").val(),
                                          },
                                        },
                                      ],
                                    };

                                    if (
                                      city1 &&
                                      city2 &&
                                      city3 &&
                                      city4 &&
                                      city5 &&
                                      city6 &&
                                      city7 &&
                                      city8 &&
                                      city9 &&
                                      city10 &&
                                      city11 &&
                                      city12 &&
                                      city13 &&
                                      city14
                                    ) {
                                      jQuery.ajax({
                                        url:
                                          window.Shopify.routes.root +
                                          "cart/add.js",
                                        type: "POST",
                                        data: formData,
                                        async: false,
                                        success: function (result) {
                                          console.log("----successfully added");
                                        },
                                      });
                                    }
                                  }
                                }
                              } else {
                                if (
                                  $(
                                    'input[name="customization13"]:checked'
                                  ).val() == "no"
                                ) {
                                  formData = {
                                    items: [
                                      {
                                        id: personalized_prod_id,
                                        quantity: 1,
                                        properties: {
                                          _Hide: true,
                                          _GroupId: $("#GroupId").val(),
                                        },
                                      },
                                      {
                                        id: 41779136888950,
                                        quantity: 1,
                                        properties: {
                                          _Hide: true,
                                          _GroupId: $("#GroupId").val(),
                                        },
                                      },
                                    ],
                                  };

                                  if (
                                    city1 &&
                                    city2 &&
                                    city3 &&
                                    city4 &&
                                    city5 &&
                                    city6 &&
                                    city7 &&
                                    city8 &&
                                    city9 &&
                                    city10 &&
                                    city11 &&
                                    city12 &&
                                    city13
                                  ) {
                                    jQuery.ajax({
                                      url:
                                        window.Shopify.routes.root +
                                        "cart/add.js",
                                      type: "POST",
                                      data: formData,
                                      async: false,
                                      success: function (result) {
                                        console.log("----successfully added");
                                      },
                                    });
                                  }
                                }
                              }
                            } else {
                              if (
                                $(
                                  'input[name="customization12"]:checked'
                                ).val() == "no"
                              ) {
                                formData = {
                                  items: [
                                    {
                                      id: personalized_prod_id,
                                      quantity: 1,
                                      properties: {
                                        _Hide: true,
                                        _GroupId: $("#GroupId").val(),
                                      },
                                    },
                                    {
                                      id: 41779136888950,
                                      quantity: 1,
                                      properties: {
                                        _Hide: true,
                                        _GroupId: $("#GroupId").val(),
                                      },
                                    },
                                  ],
                                };

                                if (
                                  city1 &&
                                  city2 &&
                                  city3 &&
                                  city4 &&
                                  city5 &&
                                  city6 &&
                                  city7 &&
                                  city8 &&
                                  city9 &&
                                  city10 &&
                                  city11 &&
                                  city12
                                ) {
                                  jQuery.ajax({
                                    url:
                                      window.Shopify.routes.root +
                                      "cart/add.js",
                                    type: "POST",
                                    data: formData,
                                    async: false,
                                    success: function (result) {
                                      console.log("----successfully added");
                                    },
                                  });
                                }
                              }
                            }
                          } else {
                            if (
                              $(
                                'input[name="customization11"]:checked'
                              ).val() == "no"
                            ) {
                              formData = {
                                items: [
                                  {
                                    id: personalized_prod_id,
                                    quantity: 1,
                                    properties: {
                                      _Hide: true,
                                      _GroupId: $("#GroupId").val(),
                                    },
                                  },
                                  {
                                    id: 41779134529654,
                                    quantity: 1,
                                    properties: {
                                      _Hide: true,
                                      _GroupId: $("#GroupId").val(),
                                    },
                                  },
                                ],
                              };

                              if (
                                city1 &&
                                city2 &&
                                city3 &&
                                city4 &&
                                city5 &&
                                city6 &&
                                city7 &&
                                city8 &&
                                city9 &&
                                city10 &&
                                city11
                              ) {
                                jQuery.ajax({
                                  url:
                                    window.Shopify.routes.root + "cart/add.js",
                                  type: "POST",
                                  data: formData,
                                  async: false,
                                  success: function (result) {
                                    console.log("----successfully added");
                                  },
                                });
                              }
                            }
                          }
                        } else {
                          if (
                            $('input[name="customization10"]:checked').val() ==
                            "no"
                          ) {
                            formData = {
                              items: [
                                {
                                  id: personalized_prod_id,
                                  quantity: 1,
                                  properties: {
                                    _Hide: true,
                                    _GroupId: $("#GroupId").val(),
                                  },
                                },
                                {
                                  id: 41779134529654,
                                  quantity: 1,
                                  properties: {
                                    _Hide: true,
                                    _GroupId: $("#GroupId").val(),
                                  },
                                },
                              ],
                            };

                            if (
                              city1 &&
                              city2 &&
                              city3 &&
                              city4 &&
                              city5 &&
                              city6 &&
                              city7 &&
                              city8 &&
                              city9 &&
                              city10
                            ) {
                              jQuery.ajax({
                                url: window.Shopify.routes.root + "cart/add.js",
                                type: "POST",
                                data: formData,
                                async: false,
                                success: function (result) {
                                  console.log("----successfully added");
                                },
                              });
                            }
                          }
                        }
                      } else {
                        if (
                          $('input[name="customization9"]:checked').val() ==
                          "no"
                        ) {
                          formData = {
                            items: [
                              {
                                id: personalized_prod_id,
                                quantity: 1,
                                properties: {
                                  _Hide: true,
                                  _GroupId: $("#GroupId").val(),
                                },
                              },
                              {
                                id: 41779134529654,
                                quantity: 1,
                                properties: {
                                  _Hide: true,
                                  _GroupId: $("#GroupId").val(),
                                },
                              },
                            ],
                          };

                          if (
                            city1 &&
                            city2 &&
                            city3 &&
                            city4 &&
                            city5 &&
                            city6 &&
                            city7 &&
                            city8 &&
                            city9
                          ) {
                            jQuery.ajax({
                              url: window.Shopify.routes.root + "cart/add.js",
                              type: "POST",
                              data: formData,
                              async: false,
                              success: function (result) {
                                console.log("----successfully added");
                              },
                            });
                          }
                        }
                      }
                    } else {
                      if (
                        $('input[name="customization8"]:checked').val() == "no"
                      ) {
                        formData = {
                          items: [
                            {
                              id: personalized_prod_id,
                              quantity: 1,
                              properties: {
                                _Hide: true,
                                _GroupId: $("#GroupId").val(),
                              },
                            },
                            {
                              id: 41779131613302,
                              quantity: 1,
                              properties: {
                                _Hide: true,
                                _GroupId: $("#GroupId").val(),
                              },
                            },
                          ],
                        };

                        if (
                          city1 &&
                          city2 &&
                          city3 &&
                          city4 &&
                          city5 &&
                          city6 &&
                          city7 &&
                          city8
                        ) {
                          jQuery.ajax({
                            url: window.Shopify.routes.root + "cart/add.js",
                            type: "POST",
                            data: formData,
                            async: false,
                            success: function (result) {
                              console.log("----successfully added");
                            },
                          });
                        }
                      }
                    }
                  } else {
                    if (
                      $('input[name="customization7"]:checked').val() == "no"
                    ) {
                      formData = {
                        items: [
                          {
                            id: personalized_prod_id,
                            quantity: 1,
                            properties: {
                              _Hide: true,
                              _GroupId: $("#GroupId").val(),
                            },
                          },
                          {
                            id: 41779131613302,
                            quantity: 1,
                            properties: {
                              _Hide: true,
                              _GroupId: $("#GroupId").val(),
                            },
                          },
                        ],
                      };

                      if (
                        city1 &&
                        city2 &&
                        city3 &&
                        city4 &&
                        city5 &&
                        city6 &&
                        city7
                      ) {
                        jQuery.ajax({
                          url: window.Shopify.routes.root + "cart/add.js",
                          type: "POST",
                          data: formData,
                          async: false,
                          success: function (result) {
                            console.log("----successfully added");
                          },
                        });
                      }
                    }
                  }
                } else {
                  if ($('input[name="customization6"]:checked').val() == "no") {
                    formData = {
                      items: [
                        {
                          id: personalized_prod_id,
                          quantity: 1,
                          properties: {
                            _Hide: true,
                            _GroupId: $("#GroupId").val(),
                          },
                        },
                        {
                          id: 41779131613302,
                          quantity: 1,
                          properties: {
                            _Hide: true,
                            _GroupId: $("#GroupId").val(),
                          },
                        },
                      ],
                    };

                    if (city1 && city2 && city3 && city4 && city5 && city6) {
                      jQuery.ajax({
                        url: window.Shopify.routes.root + "cart/add.js",
                        type: "POST",
                        data: formData,
                        async: false,
                        success: function (result) {
                          console.log("----successfully added");
                        },
                      });
                    }
                  }
                }
              } else {
                if ($('input[name="customization5"]:checked').val() == "no") {
                  formData = {
                    items: [
                      {
                        id: personalized_prod_id,
                        quantity: 1,
                        properties: {
                          _Hide: true,
                          _GroupId: $("#GroupId").val(),
                        },
                      },
                      {
                        id: 41779131613302,
                        quantity: 1,
                        properties: {
                          _Hide: true,
                          _GroupId: $("#GroupId").val(),
                        },
                      },
                    ],
                  };

                  if (city1 && city2 && city3 && city4 && city5) {
                    jQuery.ajax({
                      url: window.Shopify.routes.root + "cart/add.js",
                      type: "POST",
                      data: formData,
                      async: false,
                      success: function (result) {
                        console.log("----successfully added");
                      },
                    });
                  }
                }
              }
            } else {
              if ($('input[name="customization4"]:checked').val() == "no") {
                formData = {
                  items: [
                    {
                      id: personalized_prod_id,
                      quantity: 1,
                      properties: {
                        _Hide: true,
                        _GroupId: $("#GroupId").val(),
                      },
                    },
                    {
                      id: 41779131613302,
                      quantity: 1,
                      properties: {
                        _Hide: true,
                        _GroupId: $("#GroupId").val(),
                      },
                    },
                  ],
                };

                if (city1 && city2 && city3 && city4) {
                  jQuery.ajax({
                    url: window.Shopify.routes.root + "cart/add.js",
                    type: "POST",
                    data: formData,
                    async: false,
                    success: function (result) {
                      console.log("----successfully added");
                    },
                  });
                }
              }
            }
          } else {
            if ($('input[name="customization3"]:checked').val() == "no") {
              formData = {
                items: [
                  {
                    id: personalized_prod_id,
                    quantity: 1,
                    properties: {
                      _Hide: true,
                      _GroupId: $("#GroupId").val(),
                    },
                  },
                ],
              };

              if (city1 && city2 && city3) {
                jQuery.ajax({
                  url: window.Shopify.routes.root + "cart/add.js",
                  type: "POST",
                  data: formData,
                  async: false,
                  success: function (result) {
                    console.log("----successfully added");
                  },
                });
              }
              // }
            }
          }
        } else {
          if ($('input[name="customization2"]:checked').val() == "no") {
            formData = {
              items: [
                {
                  id: personalized_prod_id,
                  quantity: 1,
                  properties: {
                    _Hide: true,
                    _GroupId: $("#GroupId").val(),
                  },
                },
              ],
            };
            if (city1 && city2) {
              jQuery.ajax({
                url: window.Shopify.routes.root + "cart/add.js",
                type: "POST",
                data: formData,
                async: false,
                success: function (result) {
                  console.log("----successfully added");
                },
              });
            }
          }
        }
      } else {
        if ($('input[name="customization1"]:checked').val() == "no") {
          formData = {
            items: [
              {
                id: personalized_prod_id,
                quantity: 1,
                properties: {
                  _Hide: true,
                  _GroupId: $("#GroupId").val(),
                },
              },
            ],
          };
          if (city1) {
            jQuery.ajax({
              url: window.Shopify.routes.root + "cart/add.js",
              type: "POST",
              data: formData,
              async: false,
              success: function (result) {
                console.log("----successfully added");
              },
            });
          }
        }
      }
    }
  } else {
    if ($('input[name="customization"]:checked').val() == "yes") {
      let formData;
      if ($('input[name="customization1"]:checked').val() == "yes") {
        if ($('input[name="customization2"]:checked').val() == "yes") {
          if ($('input[name="customization3"]:checked').val() == "yes") {
            if ($('input[name="customization4"]:checked').val() == "yes") {
              if ($('input[name="customization5"]:checked').val() == "yes") {
                if ($('input[name="customization6"]:checked').val() == "yes") {
                  if (
                    $('input[name="customization7"]:checked').val() == "yes"
                  ) {
                    if (
                      $('input[name="customization8"]:checked').val() == "yes"
                    ) {
                      if (
                        $('input[name="customization9"]:checked').val() == "yes"
                      ) {
                        if (
                          $('input[name="customization10"]:checked').val() ==
                          "yes"
                        ) {
                          if (
                            $('input[name="customization11"]:checked').val() ==
                            "yes"
                          ) {
                            if (
                              $(
                                'input[name="customization12"]:checked'
                              ).val() == "yes"
                            ) {
                              if (
                                $(
                                  'input[name="customization13"]:checked'
                                ).val() == "yes"
                              ) {
                                if (
                                  $(
                                    'input[name="customization14"]:checked'
                                  ).val() == "yes"
                                ) {
                                  formData = {
                                    items: [
                                      {
                                        id: personalized_prod_id,
                                        quantity: 1,
                                        properties: {
                                          _Hide: true,
                                          _GroupId: $("#GroupId").val(),
                                        },
                                      },
                                      {
                                        id: 41779136888950,
                                        quantity: 1,
                                        properties: {
                                          _Hide: true,
                                          _GroupId: $("#GroupId").val(),
                                        },
                                      },
                                    ],
                                  };

                                  if (
                                    address1 &&
                                    address2 &&
                                    address3 &&
                                    address4 &&
                                    address5 &&
                                    address6 &&
                                    address7 &&
                                    address8 &&
                                    address9 &&
                                    address10 &&
                                    address111 &&
                                    address12 &&
                                    address13 &&
                                    address14 &&
                                    address15
                                  ) {
                                    jQuery.ajax({
                                      url:
                                        window.Shopify.routes.root +
                                        "cart/add.js",
                                      type: "POST",
                                      data: formData,
                                      async: false,
                                      success: function (result) {
                                        console.log("----successfully added");
                                      },
                                    });
                                  }
                                } else {
                                  if (
                                    $(
                                      'input[name="customization14"]:checked'
                                    ).val() == "no"
                                  ) {
                                    formData = {
                                      items: [
                                        {
                                          id: personalized_prod_id,
                                          quantity: 1,
                                          properties: {
                                            _Hide: true,
                                            _GroupId: $("#GroupId").val(),
                                          },
                                        },
                                        {
                                          id: 41779136888950,
                                          quantity: 1,
                                          properties: {
                                            _Hide: true,
                                            _GroupId: $("#GroupId").val(),
                                          },
                                        },
                                      ],
                                    };

                                    if (
                                      address1 &&
                                      address2 &&
                                      address3 &&
                                      address4 &&
                                      address5 &&
                                      address6 &&
                                      address7 &&
                                      address8 &&
                                      address9 &&
                                      address10 &&
                                      address111 &&
                                      address12 &&
                                      address13 &&
                                      address14
                                    ) {
                                      jQuery.ajax({
                                        url:
                                          window.Shopify.routes.root +
                                          "cart/add.js",
                                        type: "POST",
                                        data: formData,
                                        async: false,
                                        success: function (result) {
                                          console.log("----successfully added");
                                        },
                                      });
                                    }
                                  }
                                }
                              } else {
                                if (
                                  $(
                                    'input[name="customization13"]:checked'
                                  ).val() == "no"
                                ) {
                                  formData = {
                                    items: [
                                      {
                                        id: personalized_prod_id,
                                        quantity: 1,
                                        properties: {
                                          _Hide: true,
                                          _GroupId: $("#GroupId").val(),
                                        },
                                      },
                                      {
                                        id: 41779136888950,
                                        quantity: 1,
                                        properties: {
                                          _Hide: true,
                                          _GroupId: $("#GroupId").val(),
                                        },
                                      },
                                    ],
                                  };

                                  if (
                                    address1 &&
                                    address2 &&
                                    address3 &&
                                    address4 &&
                                    address5 &&
                                    address6 &&
                                    address7 &&
                                    address8 &&
                                    address9 &&
                                    address10 &&
                                    address111 &&
                                    address12 &&
                                    address13
                                  ) {
                                    jQuery.ajax({
                                      url:
                                        window.Shopify.routes.root +
                                        "cart/add.js",
                                      type: "POST",
                                      data: formData,
                                      async: false,
                                      success: function (result) {
                                        console.log("----successfully added");
                                      },
                                    });
                                  }
                                }
                              }
                            } else {
                              if (
                                $(
                                  'input[name="customization12"]:checked'
                                ).val() == "no"
                              ) {
                                formData = {
                                  items: [
                                    {
                                      id: personalized_prod_id,
                                      quantity: 1,
                                      properties: {
                                        _Hide: true,
                                        _GroupId: $("#GroupId").val(),
                                      },
                                    },
                                    {
                                      id: 41779136888950,
                                      quantity: 1,
                                      properties: {
                                        _Hide: true,
                                        _GroupId: $("#GroupId").val(),
                                      },
                                    },
                                  ],
                                };

                                if (
                                  address1 &&
                                  address2 &&
                                  address3 &&
                                  address4 &&
                                  address5 &&
                                  address6 &&
                                  address7 &&
                                  address8 &&
                                  address9 &&
                                  address10 &&
                                  address111 &&
                                  address12
                                ) {
                                  jQuery.ajax({
                                    url:
                                      window.Shopify.routes.root +
                                      "cart/add.js",
                                    type: "POST",
                                    data: formData,
                                    async: false,
                                    success: function (result) {
                                      console.log("----successfully added");
                                    },
                                  });
                                }
                              }
                            }
                          } else {
                            if (
                              $(
                                'input[name="customization11"]:checked'
                              ).val() == "no"
                            ) {
                              formData = {
                                items: [
                                  {
                                    id: personalized_prod_id,
                                    quantity: 1,
                                    properties: {
                                      _Hide: true,
                                      _GroupId: $("#GroupId").val(),
                                    },
                                  },
                                  {
                                    id: 41779134529654,
                                    quantity: 1,
                                    properties: {
                                      _Hide: true,
                                      _GroupId: $("#GroupId").val(),
                                    },
                                  },
                                ],
                              };

                              if (
                                address1 &&
                                address2 &&
                                address3 &&
                                address4 &&
                                address5 &&
                                address6 &&
                                address7 &&
                                address8 &&
                                address9 &&
                                address10 &&
                                address111
                              ) {
                                jQuery.ajax({
                                  url:
                                    window.Shopify.routes.root + "cart/add.js",
                                  type: "POST",
                                  data: formData,
                                  async: false,
                                  success: function (result) {
                                    console.log("----successfully added");
                                  },
                                });
                              }
                            }
                          }
                        } else {
                          if (
                            $('input[name="customization10"]:checked').val() ==
                            "no"
                          ) {
                            formData = {
                              items: [
                                {
                                  id: personalized_prod_id,
                                  quantity: 1,
                                  properties: {
                                    _Hide: true,
                                    _GroupId: $("#GroupId").val(),
                                  },
                                },
                                {
                                  id: 41779134529654,
                                  quantity: 1,
                                  properties: {
                                    _Hide: true,
                                    _GroupId: $("#GroupId").val(),
                                  },
                                },
                              ],
                            };

                            if (
                              address1 &&
                              address2 &&
                              address3 &&
                              address4 &&
                              address5 &&
                              address6 &&
                              address7 &&
                              address8 &&
                              address9 &&
                              address10
                            ) {
                              jQuery.ajax({
                                url: window.Shopify.routes.root + "cart/add.js",
                                type: "POST",
                                data: formData,
                                async: false,
                                success: function (result) {
                                  console.log("----successfully added");
                                },
                              });
                            }
                          }
                        }
                      } else {
                        if (
                          $('input[name="customization9"]:checked').val() ==
                          "no"
                        ) {
                          formData = {
                            items: [
                              {
                                id: personalized_prod_id,
                                quantity: 1,
                                properties: {
                                  _Hide: true,
                                  _GroupId: $("#GroupId").val(),
                                },
                              },
                              {
                                id: 41779134529654,
                                quantity: 1,
                                properties: {
                                  _Hide: true,
                                  _GroupId: $("#GroupId").val(),
                                },
                              },
                            ],
                          };

                          if (
                            address1 &&
                            address2 &&
                            address3 &&
                            address4 &&
                            address5 &&
                            address6 &&
                            address7 &&
                            address8 &&
                            address9
                          ) {
                            jQuery.ajax({
                              url: window.Shopify.routes.root + "cart/add.js",
                              type: "POST",
                              data: formData,
                              async: false,
                              success: function (result) {
                                console.log("----successfully added");
                              },
                            });
                          }
                        }
                      }
                    } else {
                      if (
                        $('input[name="customization8"]:checked').val() == "no"
                      ) {
                        formData = {
                          items: [
                            {
                              id: personalized_prod_id,
                              quantity: 1,
                              properties: {
                                _Hide: true,
                                _GroupId: $("#GroupId").val(),
                              },
                            },
                            {
                              id: 41779131613302,
                              quantity: 1,
                              properties: {
                                _Hide: true,
                                _GroupId: $("#GroupId").val(),
                              },
                            },
                          ],
                        };

                        if (
                          address1 &&
                          address2 &&
                          address3 &&
                          address4 &&
                          address5 &&
                          address6 &&
                          address7 &&
                          address8
                        ) {
                          jQuery.ajax({
                            url: window.Shopify.routes.root + "cart/add.js",
                            type: "POST",
                            data: formData,
                            async: false,
                            success: function (result) {
                              console.log("----successfully added");
                            },
                          });
                        }
                      }
                    }
                  } else {
                    if (
                      $('input[name="customization7"]:checked').val() == "no"
                    ) {
                      formData = {
                        items: [
                          {
                            id: personalized_prod_id,
                            quantity: 1,
                            properties: {
                              _Hide: true,
                              _GroupId: $("#GroupId").val(),
                            },
                          },
                          {
                            id: 41779131613302,
                            quantity: 1,
                            properties: {
                              _Hide: true,
                              _GroupId: $("#GroupId").val(),
                            },
                          },
                        ],
                      };

                      if (
                        address1 &&
                        address2 &&
                        address3 &&
                        address4 &&
                        address5 &&
                        address6 &&
                        address7
                      ) {
                        jQuery.ajax({
                          url: window.Shopify.routes.root + "cart/add.js",
                          type: "POST",
                          data: formData,
                          async: false,
                          success: function (result) {
                            console.log("----successfully added");
                          },
                        });
                      }
                    }
                  }
                } else {
                  if ($('input[name="customization6"]:checked').val() == "no") {
                    formData = {
                      items: [
                        {
                          id: personalized_prod_id,
                          quantity: 1,
                          properties: {
                            _Hide: true,
                            _GroupId: $("#GroupId").val(),
                          },
                        },
                        {
                          id: 41779131613302,
                          quantity: 1,
                          properties: {
                            _Hide: true,
                            _GroupId: $("#GroupId").val(),
                          },
                        },
                      ],
                    };

                    if (
                      address1 &&
                      address2 &&
                      address3 &&
                      address4 &&
                      address5 &&
                      address6
                    ) {
                      jQuery.ajax({
                        url: window.Shopify.routes.root + "cart/add.js",
                        type: "POST",
                        data: formData,
                        async: false,
                        success: function (result) {
                          console.log("----successfully added");
                        },
                      });
                    }
                  }
                }
              } else {
                if ($('input[name="customization5"]:checked').val() == "no") {
                  formData = {
                    items: [
                      {
                        id: personalized_prod_id,
                        quantity: 1,
                        properties: {
                          _Hide: true,
                          _GroupId: $("#GroupId").val(),
                        },
                      },
                      {
                        id: 41779131613302,
                        quantity: 1,
                        properties: {
                          _Hide: true,
                          _GroupId: $("#GroupId").val(),
                        },
                      },
                    ],
                  };

                  if (
                    address1 &&
                    address2 &&
                    address3 &&
                    address4 &&
                    address5
                  ) {
                    jQuery.ajax({
                      url: window.Shopify.routes.root + "cart/add.js",
                      type: "POST",
                      data: formData,
                      async: false,
                      success: function (result) {
                        console.log("----successfully added");
                      },
                    });
                  }
                }
              }
            } else {
              if ($('input[name="customization4"]:checked').val() == "no") {
                if (
                  $('input[name="customize_option_1"]:checked').val() &&
                  $('input[name="customize_option_2"]:checked').val() &&
                  $('input[name="customize_option_3"]:checked').val() &&
                  $("#address_4").val()
                ) {
                  formData = {
                    items: [
                      {
                        id: personalized_prod_id,
                        quantity: 1,
                        properties: {
                          _Hide: true,
                          _GroupId: $("#GroupId").val(),
                        },
                      },
                      {
                        id: 41779131613302,
                        quantity: 1,
                        properties: {
                          _Hide: true,
                          _GroupId: $("#GroupId").val(),
                        },
                      },
                    ],
                  };

                  if (address1 && address2 && address3) {
                    jQuery.ajax({
                      url: window.Shopify.routes.root + "cart/add.js",
                      type: "POST",
                      data: formData,
                      async: false,
                      success: function (result) {
                        console.log("----successfully added");
                      },
                    });
                  }
                }
              }
            }
          } else {
            if ($('input[name="customization3"]:checked').val() == "no") {
              if (
                $('input[name="customize_option_1"]:checked').val() &&
                $('input[name="customize_option_2"]:checked').val() &&
                $('input[name="customize_option_3"]:checked').val()
              ) {
                formData = {
                  items: [
                    {
                      id: personalized_prod_id,
                      quantity: 1,
                      properties: {
                        _Hide: true,
                        _GroupId: $("#GroupId").val(),
                      },
                    },
                  ],
                };

                if (address1 && address2 && address3) {
                  jQuery.ajax({
                    url: window.Shopify.routes.root + "cart/add.js",
                    type: "POST",
                    data: formData,
                    async: false,
                    success: function (result) {
                      console.log("----successfully added");
                    },
                  });
                }
              }
            }
          }
        } else {
          if ($('input[name="customization2"]:checked').val() == "no") {
            if (
              $('input[name="customize_option_1"]:checked').val() &&
              $('input[name="customize_option_2"]:checked').val()
            ) {
              formData = {
                items: [
                  {
                    id: personalized_prod_id,
                    quantity: 1,
                    properties: {
                      _Hide: true,
                      _GroupId: $("#GroupId").val(),
                    },
                  },
                ],
              };
              if (address1 && address2) {
                jQuery.ajax({
                  url: window.Shopify.routes.root + "cart/add.js",
                  type: "POST",
                  data: formData,
                  async: false,
                  success: function (result) {
                    console.log("----successfully added");
                  },
                });
              }
            }
          }
        }
      } else {
        if ($('input[name="customization1"]:checked').val() == "no") {
          if ($('input[name="customize_option_1"]:checked').val()) {
            formData = {
              items: [
                {
                  id: personalized_prod_id,
                  quantity: 1,
                  properties: {
                    _Hide: true,
                    _GroupId: $("#GroupId").val(),
                  },
                },
              ],
            };
            if (address1) {
              jQuery.ajax({
                url: window.Shopify.routes.root + "cart/add.js",
                type: "POST",
                data: formData,
                async: false,
                success: function (result) {
                  console.log("----successfully added");
                },
              });
            }
          }
        }
      }
    }
  }
});
